module.exports = __webpack_public_path__ + "img/c.0698fdd8.jpg";